module.exports = __webpack_public_path__ + "img/mouse_white.d9f6bf04.svg";